/** @jsxImportSource @emotion/react */

import { useEffect } from 'react';
import { useTheme } from '@emotion/react';

import { data, TarotCard } from '../Data';
import { loadScript } from '../../utilities/load-script';

declare global {
  interface Window {
    addthis: {
      layers: {
        refresh: () => void;
      };
    };

    addthis_share: any;

    addthis_config: any;
  }
}

type socialProps = {
  resultDetails: TarotCard;
};

export const Social = ({ resultDetails }: socialProps) => {
  const theme = useTheme();

  const url = `${window.location.protocol}//${window.location.hostname}/${resultDetails.slug}`;
  const title = resultDetails.socialMediaTitle;

  useEffect(() => {
    window.addthis_share = {
      url_transforms: {
        shorten: {
          twitter: 'bitly'
        }
      },
      passthrough: {
        twitter: {
          via: 'habaneroconsult'
        }
      }
    };

    window.addthis_config = window.addthis_config || {};
    window.addthis_config.data_track_addressbar = false;
    window.addthis_config.data_track_clickback = false;

    loadScript('https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-4d77b44b1a103b83');

    if (window.addthis?.layers?.refresh) {
      window.addthis.layers.refresh();
    }
  }, [resultDetails]);

  return (
    <div className="ad">
      <div>
        <p
          css={{
            fontSize: theme.fontSizes[4],
            fontWeight: theme.fontWeights.bold
          }}
        >
          {data.dictionary.share}
        </p>
      </div>
      <div>
        <div
          className="addthis_inline_share_toolbox_f0an"
          css={{
            '.at-resp-share-element.at-mobile .at-share-btn': {
              marginRight: '1rem',

              '&:focus:not(:focus-visible)': {
                outline: 'none',
              }
            },

            '.at-resp-share-element .at-share-btn': {
              marginRight: '1.5rem',

              '&:webkitDirectFocus': {
                outlineWidth: '1px'
              },

              '&:focus:not(:focus-visible)': {
                outline: 'none',
              }
            }
          }}
          data-url={url}
          data-title={title}
        />
      </div>
    </div>
  );
};

Social.displayName = 'Social';
